export const APP_DEFAULTS = {
	searchByPastSevenDays: 2,
	timeBreakdown: 'd',
} as const;

export const APP_PAGINATION_DEFAULTS = {
	start: 0,
	limit: 50,
} as const;
